import { ClothingProfileDispositionsComponent } from './content-page/common/employee-assets/clothing-profile-dispositions.component';
import { EmployeeServiceAnchorDirective } from './content-page/common/employee-assets/employee-service-anchor.directive';
import { WorkflowModalFocusDirective } from './content-page/common/employee-assets/workflow-modal-focus.directive';
import { OffboardingHistoryEventComponent } from './content-page/offboarding/offboarding-history-event.component';
import { OffboardingPersonSearchComponent } from './content-page/offboarding/offboarding-person-search.component';
import { OffboardingAssignmentEditorComponent } from './content-page/offboarding/offboarding-assignment-editor.component';
import { OffboardingItemComponent } from './content-page/offboarding/offboarding-item.component';
import { OffboardingCollectionComponent } from './content-page/offboarding/offboarding-collection.component';
import { OffboardingApprovalComponent } from './content-page/offboarding/offboarding-approval.component';
import { OffboardingReplacementsComponent } from './content-page/offboarding/offboarding-replacements.component';
import { OffboardingNotePreviewComponent } from './content-page/offboarding/offboarding-note-preview.component';
import { OffboardingNoteViewService } from './content-page/offboarding/offboarding-note-view.service';
import { OffboardingReturnsComponent } from './content-page/offboarding/offboarding-returns.component';
import { OffboardingReturnModalComponent } from './content-page/offboarding/offboarding-return-modal.component';
import { OffboardingReturnGateway } from './content-page/offboarding/offboarding-return.gateway';
import { OffboardingPayrollComponent } from './content-page/offboarding/offboarding-payroll.component';
import { OffboardingNotificationComponent } from './content-page/offboarding/offboarding-notification.component';
import { WorkflowTimestampPipe } from './pipes/workflow-timestamp.pipe';
import { UtcCalendarDatePipe } from './pipes/utc-calendar-date.pipe';
import { AssetIssueModalComponent } from './content-page/common/employee-assets/asset-issue-modal.component';
import { DepartmentAssetsModalComponent } from './content-page/common/employee-assets/department-assets-modal.component';
import { AssetProfileIssueComponent } from './content-page/common/employee-assets/asset-profile-issue.component';
import { AssetActionModalComponent } from './content-page/common/employee-assets/asset-action-modal.component';
import { ClothingDispositionComponent } from './content-page/common/employee-assets/clothing-disposition.component';
import { ClothingDispositionModalComponent } from './content-page/common/employee-assets/clothing-disposition-modal.component';
import { OffboardingProfileComponent } from './content-page/offboarding/offboarding-profile.component';
import { OffboardingUnavailableComponent } from './content-page/offboarding/offboarding-unavailable.component';
import { OffboardingListComponent } from './content-page/offboarding/offboarding-list.component';
import { OffboardingArchiveDetailComponent } from './content-page/offboarding/offboarding-archive-detail.component';
import { OffboardingArchiveImportComponent } from './content-page/offboarding/offboarding-archive-import.component';
import { OffboardingCreateComponent } from './content-page/offboarding/offboarding-create.component';
import { OffboardingDetailComponent } from './content-page/offboarding/offboarding-detail.component';
import { OffboardingBraceDirective } from './content-page/offboarding/offboarding-brace.directive';
import { OffboardingActionModalComponent } from './content-page/offboarding/offboarding-action-modal.component';
import { OffboardingAssignmentsComponent } from './content-page/offboarding/offboarding-assignments.component';
import { EmployeeAssetsService } from './services/employee-assets.service';
import { ClothingDispositionService } from './services/clothing-disposition.service';
import { OffboardingService } from './services/offboarding.service';
import { WorkflowPageGuard } from './services/workflow-page.guard';
import { WorkflowMenuDirective } from './navbar/workflow-menu.directive';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {Autosize} from 'ng-autosize';
import {AppComponent} from './app.component';
import {PwaPlatform} from './services/pwa-platform.service';
import {PwaModeService} from './services/pwa-mode.service';
import {PwaInstallService} from './services/pwa-install.service';
import {PwaRouteGuard} from './services/pwa-route.guard';
import {PwaSuggestionLeaveGuard} from './services/pwa-suggestion-leave.guard';
import {PwaLandingService} from './services/pwa-landing.service';
import {PwaDashboardLandingComponent} from './content-page/pwa/pwa-dashboard-landing.component';
import {PwaInstallHelpComponent} from './content-page/pwa/pwa-install-help.component';
import {BrowserOnlyDirective, PwaOnlyDirective, PwaModeDirective} from './navbar/browser-only.directive';
import {PwaInstallDirective} from './header/pwa-install.directive';
import {PhonePrimaryDepartmentLinkDirective} from './navbar/phone-primary-department-link.directive';
import {HeaderComponent} from './header/header.component';
import {SigninComponent} from './auth/signin/signin.component';
import {NavbarComponent} from './navbar/navbar.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ContentPageComponent} from './content-page/content-page.component';
import {RouterModule, Routes} from '@angular/router';
import {Http, HttpModule, JsonpModule, RequestOptions, XHRBackend} from '@angular/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MyGroupsComponent} from './content-page/my-groups/my-groups.component';
import {MyStandardsComponent} from './content-page/my-standards/my-standards.component';
import {MyStandardsCatalogComponent} from './content-page/my-standards/my-standards-catalog.component';
import {PhoneStandardsComponent} from './content-page/my-standards/phone-standards.component';
import {MyWorkingReportComponent} from './content-page/my-working-report/my-working-report.component';
import {
  DealPayrollDetailComponent
} from './content-page/my-working-report/deal-payroll-detail/deal-payroll-detail.component';
import {
  DealPayrollDetailTriggerDirective
} from './content-page/my-working-report/deal-payroll-detail/deal-payroll-detail-trigger.directive';
import {HomeTasksComponent} from './content-page/home-tasks/home-tasks.component';
import {MyProfileComponent} from './content-page/my-profile/my-profile.component';
import {MyProfileSummaryComponent} from './content-page/my-profile/my-profile-summary.component';
import {MyProfileAssetsComponent} from './content-page/my-profile/my-profile-assets.component';
import {StandardPinsComponent} from './content-page/admin/standards-management/standard-pins.component';
import { StandardPinCheckboxComponent } from './content-page/admin/standards-management/standard-pin-checkbox.component';
import { StandardAssignmentPinsDirective } from './content-page/admin/standards-management/standard-assignment-pins.directive';
import {GradeGrowthComponent} from './content-page/common/grade-growth/grade-growth.component';
import {GradePromotionComponent} from './content-page/common/grade-growth/grade-promotion.component';
import {DropdownDirective} from './header/dropdown.directive';
import {NgxPaginationModule} from 'ngx-pagination';
import {TreeTableModule, TreeNode} from 'primeng/primeng';
import {AngularFontAwesomeModule} from 'angular-font-awesome';
import { NotifierModule } from 'angular-notifier';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {UserService} from './services/user.service';
import {UserReportService} from './services/user-report.service';
import {AuthService} from './services/auth.service';
import {AuthGuard} from './services/auth-guard.service';
import {CreateSchedulePopupComponent} from './content-page/admin/create-schedule-popup/create-schedule-popup.component';
import {ApiConnectService} from './services/api-connect.service';
import {AdminService} from './services/admin.service';
import {ClothingService} from './services/clothing.service';
import {ClothingErrorService} from './services/clothing-error.service';
import {ClothingNotificationActionService} from './services/clothing-notification-action.service';
import {ClothingNotificationDisplayService} from './services/clothing-notification-display.service';
import {ClothingNotificationRoutingService} from './services/clothing-notification-routing.service';
import {ProfileClothingViewService} from './services/profile-clothing-view.service';
import {CreateUserComponent} from './content-page/admin/create-user/create-user.component';
import {UsersComponent} from './content-page/admin/users/users.component';
import {AdminClothingSettingsComponent} from './content-page/admin/clothing/clothing-settings.component';
import {AdminClothingAssignmentsComponent} from './content-page/admin/clothing/clothing-assignments.component';
import {AdminClothingReportComponent} from './content-page/admin/clothing/clothing-report.component';
import {
  ClothingProcurementForecastComponent
} from './content-page/admin/clothing/clothing-procurement-forecast.component';
import {ClothingCatalogModalComponent} from './content-page/admin/clothing/clothing-catalog-modal.component';
import {ClothingAdminSettingsFormComponent} from './content-page/admin/clothing/clothing-admin-settings-form.component';
import {ClothingAdminMarkerDirectoryComponent} from './content-page/admin/clothing/clothing-admin-marker-directory.component';
import {ClothingAdminPersonalNormsComponent} from './content-page/admin/clothing/clothing-admin-personal-norms.component';
import {ClothingAdminMatrixComponent} from './content-page/admin/clothing/clothing-admin-matrix.component';
import {ClothingAdminDepartmentMarkerComponent} from './content-page/admin/clothing/clothing-admin-department-marker.component';
import {ClothingMarkerModalComponent} from './content-page/admin/clothing/clothing-marker-modal.component';
import {ClothingMarkerAssignmentPanelComponent} from './content-page/admin/clothing/clothing-marker-assignment-panel.component';
import {CreateGroupComponent} from './content-page/admin/create-group/create-group.component';
import {SidebarService} from './services/side-bar.service';
import {CreatePositionComponent} from './content-page/admin/create-position/create-position.component';
import {DealPayrollCatalogComponent} from './content-page/admin/deal-payroll-catalog/deal-payroll-catalog.component';
import {DealPayrollRatesComponent} from './content-page/admin/deal-payroll-catalog/deal-payroll-rates.component';
import {TasksPanelComponent} from './tasks-panel/tasks-panel.component';
import {CompanyStructureComponent} from './content-page/company-structure/company-structure.component';
import {CreateStandardComponent} from './content-page/admin/create-standard/create-standard.component';
import {AllStandardsComponent} from './content-page/admin/all-standards/all-standards.component';
import {EditStandardComponent} from './content-page/admin/edit-standard/edit-standard.component';
import {ViewStandardComponent} from './content-page/views/view-standard/view-standard.component';
import {ViewGroupComponent} from './content-page/views/view-group/view-group.component';
import {DealPayrollGroupSettingsComponent} from './content-page/views/view-group/deal-payroll-group-settings/deal-payroll-group-settings.component';
import {DealPayrollDecimalInputDirective} from './content-page/views/view-group/deal-payroll-group-settings/deal-payroll-decimal-input.directive';
import {DealPayrollGroupSettingsTriggerDirective} from './content-page/views/view-group/deal-payroll-group-settings/deal-payroll-group-settings-trigger.directive';
import {ViewUserProfileComponent} from './content-page/views/view-user-profile/view-user-profile.component';
import {DealPayrollUserSettingsComponent} from './content-page/views/view-user-profile/deal-payroll-user-settings/deal-payroll-user-settings.component';
import {ViewUserReportComponent}
  from './content-page/views/view-user-report/view-user-report.component';
import {
  DEAL_PAYROLL_SETTINGS_ROUTE_DATA,
  GENERAL_SETTINGS_ROUTE_DATA
} from './content-page/views/view-user-report/view-user-report.option';
import {ViewUserTasksComponent} from './content-page/views/view-user-tasks/view-user-tasks.component';
import {EditUserProfileComponent} from './content-page/views/edit-user-profile/edit-user-profile.component';
import {ChunkPipe, TaskFullviewPopupComponent} from './content-page/views/task-fullview-popup/task-fullview-popup.component';
import {CalendarTimezoneMarkerModalComponent} from './content-page/views/task-fullview-popup/calendar-timezone-marker-modal.component';
import {CalendarTimezoneDataService} from './content-page/views/task-fullview-popup/calendar-timezone-data.service';
import {TestingPageComponent} from './content-page/views/testing-page/testing-page.component';
import {StandardContentTranslationPipe} from './pipes/standard-content-translation.pipe';
import {ContentTranslationPipe} from './pipes/content-translation.pipe';
import {ApiService} from './services/api.service';
import {TaskPipePipe} from './tasks-panel/task-pipe.pipe';
import {TaskDescService} from './services/task-desc.service';
import {TaskBarService} from './services/task-bar.service';
import {ErrorInterceptor} from './services/error-interceptor.service';
import {NgbModule, NgbDropdown, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ReportDatepickerComponent} from './modals/report-datepicker.component';
import {ReportService} from './services/report.service';
import {DealPayrollService} from './services/deal-payroll.service';
import {DealPayrollSettingsService} from './services/deal-payroll-settings.service';
import {GradePromotionService} from './services/grade-promotion.service';
import {AddMemberPopupComponent} from './content-page/views/view-group/popups/add-member-popup/add-member-popup.component';
import {EditGroupPopupComponent} from './content-page/views/view-group/popups/edit-group-popup/edit-group-popup.component';
import {SetHeadDeputyComponent} from './content-page/views/view-group/popups/set-head-deputy/set-head-deputy.component';
import {ViewStandardsComponent} from './content-page/views/view-group/popups/view-standards/view-standards.component';
import {ConfirmationPopupComponent} from './content-page/views/view-group/popups/confirmation-popup/confirmation-popup.component';
import {EmployeeStandardOverridesModalComponent} from './content-page/views/view-group/popups/employee-standard-overrides/employee-standard-overrides-modal/employee-standard-overrides-modal.component';
import {EmployeeStandardUserSelectorComponent} from './content-page/views/view-group/popups/employee-standard-overrides/employee-standard-user-selector/employee-standard-user-selector.component';
import {EmployeeStandardMatrixComponent} from './content-page/views/view-group/popups/employee-standard-overrides/employee-standard-matrix/employee-standard-matrix.component';
import {ClothingMarkerOverridesModalComponent} from './content-page/views/view-group/popups/clothing-marker-overrides/clothing-marker-overrides-modal.component';
import {TestGuard} from './services/test-guard.service';
import {BiometryGuard} from './services/biometry-guard.service';
import {EditGroupDetailsComponent} from './content-page/views/edit-group-details/edit-group-details.component';
import {NgBootstrapFormValidationModule} from 'ng-bootstrap-form-validation';
import {BlanksStandardComponent} from './content-page/views/blanks-standard/blanks-standard.component';
import {StandardDisseminationComponent} from './content-page/views/standard-dissemination/standard-dissemination.component';
import {StandardAssignmentCleanupComponent} from './content-page/common/standard-assignment-cleanup/standard-assignment-cleanup.component';
import {FabMessageService} from './services/fab-message.service';
import {AddNewQuestionsComponent} from './content-page/views/view-standard/popups/add-new-questions/add-new-questions.component';
import {EditStandardInfoComponent} from './content-page/views/view-standard/popups/edit-standard-info/edit-standard-info.component';
import {TimeFormatterService} from './services/time-formatter.service';
import {ChangeUserPositionComponent} from './content-page/views/view-group/popups/change-user-position/change-user-position.component';
import {RenamePositionComponent} from './content-page/views/view-group/popups/rename-position/rename-position.component';
import {ChangeSalaryComponent} from './content-page/views/view-user-profile/change-salary/change-salary.component';
import {InfoPopupComponent} from './content-page/views/view-group/popups/info-popup/info-popup.component';
import {ChangeUserPasswordComponent} from './content-page/views/view-group/popups/change-user-password/change-user-password.component';
import {TestingService} from './services/testing.service';
import {HeaderService} from './services/header.service';
import {MobileMenuService} from './services/mobile-menu.service';
import {WorkTimeService} from './services/work-time.service';
import {ComponentBackgroundService} from './services/component-background.service';
import {OperatingStandardComponent} from './content-page/operating-standard/operating-standard.component';
import {HeadNotificationComponent} from './content-page/operating-standard/head-notification/head-notification.component';
import {EmployeeProbationComponent} from './content-page/common/employee-probation/employee-probation.component';
import {EmployeeOnboardingComponent} from './header/employee-onboarding/employee-onboarding.component';
import {EmployeeOnboardingService} from './services/employee-onboarding.service';
import {SalarySourcesComponent} from './content-page/common/salary-sources/salary-sources.component';
import {CreateOperatingStandardComponent} from './content-page/admin/create-operating-standard/create-operating-standard.component';
import {OperatingStandardListAllComponent} from './content-page/admin/operating-standard-list-all/operating-standard-list-all.component';
import {OpstStepOneComponent} from './content-page/admin/create-operating-standard/opst-step-one/opst-step-one.component';
import {OpstStepTwoComponent} from './content-page/admin/create-operating-standard/opst-step-two/opst-step-two.component';
import {OpstStepThreeComponent} from './content-page/admin/create-operating-standard/opst-step-three/opst-step-three.component';
import {OpstStepFourComponent} from './content-page/admin/create-operating-standard/opst-step-four/opst-step-four.component';
import {OpstStepFiveComponent} from './content-page/admin/create-operating-standard/opst-step-five/opst-step-five.component';
import {OpstStepSixComponent} from './content-page/admin/create-operating-standard/opst-step-six/opst-step-six.component';
import {OpstStepSevenComponent} from './content-page/admin/create-operating-standard/opst-step-seven/opst-step-seven.component';
import {StandardActionModalComponent} from './content-page/admin/operating-standard-list-all/modal/standard-action-modal/standard-action-modal.component';
import {OperatingStandardService} from './services/operating-standard.service';
import {CanDeactivateGuardService} from './services/can-deactivate-guard.service';
import {AddStandardPrefixComponent} from './content-page/admin/create-standard/modal/add-standard-prefix/add-standard-prefix.component';
import {AddStandardPrefixComponentHead} from './content-page/admin/create-standard-head/modal/add-standard-prefix/add-standard-prefix.component';
import {EditStandardPrefixComponentHead} from './content-page/admin/create-standard-head/modal/edit-standard-prefix/edit-standard-prefix.component';
import {AddStandardTypeComponentHead} from './content-page/admin/create-standard-head/modal/add-standard-type/add-standard-type.component';
import {EditStandardTypeComponentHead} from './content-page/admin/create-standard-head/modal/edit-standard-type/edit-standard-type.component';
import {EditStandardNumberComponentHead} from './content-page/admin/create-standard-head/modal/edit-standard-number/edit-standard-number.component';
import {EditStandardPrefixComponent} from './content-page/admin/create-standard/modal/edit-standard-prefix/edit-standard-prefix.component';
import {PrefixService} from './services/prefix.service';
import {StandardTypesService} from './services/standard-types.service';
import {AddStandardTypeComponent} from './content-page/admin/create-standard/modal/add-standard-type/add-standard-type.component';
import {EditStandardTypeComponent} from './content-page/admin/create-standard/modal/edit-standard-type/edit-standard-type.component';
import {StepsControllerService} from './services/steps-controller.service';
import {NotificationsService} from './services/notifications.service';
import {ToastService} from './services/toast.service';
import {EmployeeStandardOverridesService} from './services/employee-standard-overrides.service';
import {MorningOvertimePromptContainerComponent} from './content-page/common/morning-overtime-readiness/containers/morning-overtime-prompt-container/morning-overtime-prompt-container.component';
import {MorningOvertimePromptComponent} from './content-page/common/morning-overtime-readiness/components/morning-overtime-prompt/morning-overtime-prompt.component';
import {MorningOvertimeHeadActionComponent} from './content-page/common/morning-overtime-readiness/components/morning-overtime-head-action/morning-overtime-head-action.component';
import {MorningOvertimeReadinessApiService} from './content-page/common/morning-overtime-readiness/services/morning-overtime-readiness-api.service';
import {MorningOvertimeReadinessFacadeService} from './content-page/common/morning-overtime-readiness/services/morning-overtime-readiness-facade.service';
import {VacationApiService} from './content-page/common/vacation/vacation-api.service';
import {VacationBookingPanelComponent} from './content-page/common/vacation/vacation-booking-panel.component';
import {
  VacationAvailabilityCalendarComponent
} from './content-page/common/vacation/vacation-availability-calendar.component';
import {VacationPresenceBadgeComponent} from './content-page/common/vacation/vacation-presence-badge.component';
import {VacationTeamCalendarComponent} from './content-page/common/vacation/vacation-team-calendar.component';
import {SkillLearningModule} from './content-page/common/skill-learning/skill-learning.module';
import {SkillSpecializationListContainerComponent} from './content-page/common/skill-learning/components/admin/specialization-list-container/specialization-list-container.component';
import {CreateSpecializationContainerComponent} from './content-page/common/skill-learning/components/admin/create-specialization-container/create-specialization-container.component';
import {EditSpecializationContainerComponent} from './content-page/common/skill-learning/components/admin/edit-specialization-container/edit-specialization-container.component';
import {AiStatisticsContainerComponent} from './content-page/common/skill-learning/components/admin/ai-statistics-container/ai-statistics-container.component';
import {LearningTreeContainerComponent} from './content-page/common/skill-learning/components/user/learning-tree/learning-tree-container.component';
import {LearningSessionContainerComponent} from './content-page/common/skill-learning/components/user/learning-session/learning-session-container.component';
import {DepartmentStarMapComponent} from './content-page/common/skill-learning/components/user/department-star-map/department-star-map.component';
import {SkillRoleGuard} from './content-page/common/skill-learning/guards/skill-role.guard';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpClientXsrfModule} from '@angular/common/http';
import {ChatComponent} from './content-page/operating-standard/chat/chat.component';
import {UserConfirmStandardComponent} from './content-page/operating-standard/user-confirm-standard/user-confirm-standard.component';
import {UserFamiliarizeStandardComponent} from './content-page/operating-standard/user-familiarize-standard/user-familiarize-standard.component';
import {MessageService} from './content-page/operating-standard/chat/message.service';
import {StepCreateTestingComponent} from './content-page/admin/create-operating-standard/opst-step-six/step-create-testing/step-create-testing.component';
import {StepTestingService} from './content-page/admin/create-operating-standard/opst-step-six/step-create-testing/step-testing.service';
import {TestingActionComponent} from './content-page/operating-standard/user-familiarize-standard/testing-action/testing-action.component';
import {TestingProcessService} from './content-page/operating-standard/user-familiarize-standard/testing-action/testing-process.service';
import {OpstStepEightComponent} from './content-page/admin/create-operating-standard/opst-step-eight/opst-step-eight.component';
import {AddUserStepsComponent} from './content-page/admin/create-operating-standard/add-user-steps/add-user-steps.component';
import {StepConfirmPopupComponent} from './content-page/admin/create-operating-standard/step-confirm-popup/step-confirm-popup.component';
import {AddStepUserService} from './content-page/admin/create-operating-standard/add-user-steps/add-step-user.service';
import {AddQuestionStepPopupComponent} from './content-page/admin/create-operating-standard/opst-step-eight/add-question-step-popup/add-question-step-popup.component';
import {StepTempControllerService} from './services/step-temp-controller.service';
import {AddChanglogComponent} from './content-page/admin/create-operating-standard/opst-step-eight/add-changlog/add-changlog.component';
import {StepChangelogsComponent} from './content-page/admin/create-operating-standard/step-changelogs/step-changelogs.component';
import {ExNotificationsService} from './auth/signin/ex-notifications.service';
import {ExNotificationsListComponent} from './auth/signin/ex-notifications-list/ex-notifications-list.component';
import {ExNotificationsActionComponent} from './auth/signin/ex-notifications-action/ex-notifications-action.component';
import {ExNotificationFamiliarizeActionComponent} from './auth/signin/ex-notification-familiarize-action/ex-notification-familiarize-action.component';
import {ExNotificationConfirmActionComponent} from './auth/signin/ex-notification-confirm-action/ex-notification-confirm-action.component';
import {FromEmailLinkComponent} from './content-page/operating-standard/from-email-link/from-email-link.component';
import {EditStandardNumberComponent} from './content-page/admin/create-standard/modal/edit-standard-number/edit-standard-number.component';
import {LanguageSwitcherComponent} from './header/language-switcher/language-switcher/language-switcher.component';
import {TranslateStandardComponent} from './content-page/translate/translate-standard/translate-standard.component';
import {TranslateQuestionsComponent} from './content-page/translate/translate-questions/translate-questions.component';
import {LanguageSwitcher} from './header/language-switcher/language-switcher.model';
import {UiLocaleService} from './services/ui-locale.service';
import {TreeGroupPosService} from './content-page/admin/create-operating-standard/tree-group-pos-service/tree-group-pos.service';
import {TreeGroupPosBlockComponent} from './content-page/admin/create-operating-standard/tree-group-pos-service/tree-group-pos-block/tree-group-pos-block.component';
import {CreateNewSlistComponent} from './content-page/common/suggestion-lists/components/create-new-slist/create-new-slist.component';
import {MySuggestionListsComponent} from './content-page/common/suggestion-lists/components/my-suggestion-lists/my-suggestion-lists.component';
import {AllSuggestionListsComponent} from './content-page/common/suggestion-lists/components/all-suggestion-lists/all-suggestion-lists.component';
import {SuggestionListsService} from './content-page/common/suggestion-lists/services/suggestion-lists.service';
import {LearningService} from './content-page/common/learning/service/learning.service';
import {SpecializationsService} from './content-page/common/specializations/services/specializations.service';
import {SpecializationsListComponent} from './content-page/common/specializations/components/specializations-list/specializations-list.component';
import {AddNewSpecializationComponent} from './content-page/common/specializations/components/add-new-specialization/add-new-specialization.component';
import {QualificationsListComponent} from './content-page/common/qualifications/components/qualifications-list/qualifications-list.component';
import {LearningComponent} from './content-page/common/learning/components/learning/learning.component';
import {EditSpecializationComponent} from './content-page/common/specializations/components/edit-specialization/edit-specialization.component';
import {StartLearningComponent} from './content-page/common/learning/components/start-learning/start-learning.component';
import {SetLevelComponent} from './content-page/common/qualifications/components/set-level/set-level.component';
import {UserQualificationsService} from './content-page/common/qualifications/services/user-qualifications.service';
import {ViewSuggestionListComponent} from './content-page/common/suggestion-lists/components/view-suggestion-list/view-suggestion-list.component';
import {MySlTabComponent} from './content-page/common/suggestion-lists/components/my-suggestion-lists/my-sl-tab/my-sl-tab.component';
import {MyDraftsTabComponent} from './content-page/common/suggestion-lists/components/my-suggestion-lists/my-drafts-tab/my-drafts-tab.component';
import {ImplementationMembersComponent} from './content-page/common/suggestion-lists/components/view-suggestion-list/implementation-members/implementation-members.component';
import {ChatSuggestionListsService} from './content-page/common/suggestion-lists/services/chat-suggestion-lists.service';
import {ActionSlPopupComponent} from './content-page/common/suggestion-lists/components/view-suggestion-list/popups/action-sl-popup/action-sl-popup.component';
import {ForReviewSuggestionListsComponent} from './content-page/common/suggestion-lists/components/for-review-suggestion-lists/for-review-suggestion-lists.component';
import {ReviewSuggestionListsService} from './content-page/common/suggestion-lists/services/review-suggestion-lists.service';
import {ConfirmScheduleComponent} from './content-page/admin/create-schedule-popup/confirm-schedule/confirm-schedule.component';
import {SpecWarningComponent} from './content-page/common/specializations/components/spec-warning/spec-warning.component';
import {ViewDocxComponent} from './content-page/views/view-docx/view-docx.component';
import {ViewDocxService} from './services/view-docx.service';
import {StepsFilesComponent} from './content-page/admin/create-operating-standard/steps-files/steps-files.component';
import { StepsBlanksComponent } from './content-page/admin/create-operating-standard/steps-blanks/steps-blanks.component';
import { AlertShowComponent } from './content-page/common/alert-show/alert-show.component';
import { EditQuestionComponent } from './content-page/admin/create-operating-standard/opst-step-eight/edit-question-step-popup/edit-question.component';
import { EditStandardNumberPopupComponent } from './content-page/admin/create-operating-standard/opst-step-eight/edit-standard-number-popup/edit-standard-number-popup.component';
import { StandardsManagementComponent } from './content-page/admin/standards-management/standards-management.component';
import { MyCreatedStandards } from './content-page/admin/my-created-standards/my-created-standards.component';
import { StdManagementService } from './content-page/admin/standards-management/std-management.service';
import { RemoveUserComponent } from './content-page/admin/standards-management/modals/remove-user/remove-user.component';
import { AssignStandardsComponent } from './content-page/admin/standards-management/modals/assign-standards/assign-standards.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { SortTableService } from './services/sort-table.service';
import { ConfirmDelete } from './modals/confirmDelete/confirmDelete.component';
import { SearchParams } from './modals/users-search-params/users-search-params.component';
import { AddDepartments } from './modals/addDepartments/add-departments.component';
import { CancelPopupComponent } from './content-page/common/suggestion-lists/components/view-suggestion-list/popups/cancel-popup/cancel-popup.component';
import { ClothingItemNameKeyPipe } from './pipes/clothing-item-name-key.pipe';
import { RenamePipe } from './pipes/rename.pipe';
import { SuggestionStatusKeyPipe } from './pipes/suggestion-status-key.pipe';
import { CreateStandardHeadComponent } from './content-page/admin/create-standard-head/create-standard.component';
import { StandartTabsComponent } from './content-page/admin/standart-tabs/standart-tabs.component';
import { StandartTabsHeadComponent } from './content-page/admin/standart-tabs-head/standart-tabs-head.component';
import { DepartmentsTabsUserComponent } from './content-page/admin/departments-tabs-user/departments-tabs-user.component';
import { StandartsTabsAdminComponent } from './content-page/admin/standarts-tabs-admin/standarts-tabs-admin.component';
import { AchievementsComponent } from './content-page/achievements/achievements.component';
import { ChangeKarmaDescriptionComponent } from './content-page/views/view-group/change-karma-description/change-karma-description.component';
import { VectorValueComponent} from './content-page/views/view-group/vector-value/vector-value.component';
import { GetClotheComponent } from './content-page/views/view-user-profile/get-clothe/get-clothe.component';
import { BiometricsComponent } from './content-page/views/view-user-profile/biometrics/biometrics.component';
import { BiometryRequiredComponent } from './content-page/views/biometry-required/biometry-required.component';
import { ChangePassComponent } from './auth/change-pass/change-pass.component';
import { DislikeListComponent } from './content-page/my-working-report/dislike-list/dislike-list.component';
import { ChangeModalComponent } from './content-page/views/view-user-report/change-modal/change-modal.component';
import { ChangeModalsComponent } from './content-page/views/task-fullview-popup/change-modals/change-modals.component';
import { ThermometerComponent } from './content-page/thermometer/thermometer.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SwitchComponent } from './modals/switch/switch.component';
import { UsersStandartsReportComponent } from './content-page/admin/users/users-standarts-report/users-standarts-report.component';
import { TestingDataService } from './content-page/views/testing-page/testing.service';
import { ChangeExperienceComponent } from './content-page/views/view-user-profile/change-experience/change-experience.component';
import { UpdateService } from './modals/report.service';
import { ConfirmPopupComponent } from './content-page/views/view-group/popups/confirm-popup copy/confirm-popup.component';
import { DisableKeyboardInputDirective } from './content-page/views/edit-group-details/disable-keyboard-input.directive';
import { CustomTooltipDirective } from './content-page/my-working-report/custom-tooltip.directive';
import { SafeHtmlPipe } from './content-page/views/edit-group-details/safe-html.pipe';
import { ClothingHeadExtensionModalComponent } from './modals/clothing-head-extension-modal.component';
import { ClothingHeadLossDecisionModalComponent } from './modals/clothing-head-loss-decision-modal.component';
import { ClothingIssueModalComponent } from './modals/clothing-issue-modal.component';
import { ClothingLossModalComponent } from './modals/clothing-loss-modal.component';
import { ClothingStorekeeperRequestActionModalComponent } from './modals/clothing-storekeeper-request-action-modal.component';
import { StorekeeperEmployeesComponent } from './content-page/storekeeper-employees/storekeeper-employees.component';
import { StandardDiscussionPageComponent } from './content-page/common/standard-discussion/containers/standard-discussion-page/standard-discussion-page.component';
import { StandardDiscussionApiService } from './content-page/common/standard-discussion/services/standard-discussion-api.service';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './../assets/i18n/', '.json?from=' + new Date().getTime());
}

export const appRoutes: Routes = [
  {path: '', redirectTo: '/dashboard', pathMatch: 'full', canActivate: [AuthGuard]},
  {
    path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard, BiometryGuard], canActivateChild: [PwaRouteGuard], children: [
      {path: '', component: PwaDashboardLandingComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'thermometer', component: ThermometerComponent, canActivate: [AuthGuard, TestGuard]},
      {
        path: 'calendar',
        component: TaskFullviewPopupComponent,
        canActivate: [AuthGuard, TestGuard, SkillRoleGuard],
        data: {roles: ['ROLE_ADMIN'], fullscreenLayout: true}
      },
      {path: 'home', component: HomeTasksComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'offboarding', component: OffboardingUnavailableComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'offboarding/assignments', redirectTo: 'admin/clothing/responsibilities', pathMatch: 'full'},
      {path: 'offboarding/new/:employeeId', component: OffboardingUnavailableComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'offboarding/:id', component: OffboardingUnavailableComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/clothing/responsibilities', component: AdminClothingSettingsComponent, canActivate: [AuthGuard, TestGuard, SkillRoleGuard], data: {roles: ['ROLE_ADMIN'], section: 'responsibilities'}},
      {path: 'profile', component: MyProfileComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'groups', component: MyGroupsComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'standards', component: MyStandardsCatalogComponent, canActivate: [AuthGuard]},
      {path: 'report', component: MyWorkingReportComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'report/:id', component: MyWorkingReportComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'biometry', component: BiometryRequiredComponent, canActivate: [AuthGuard]},
      {path: 'testing', component: TestingPageComponent, canActivate: [AuthGuard]},
      {path: 'admin/create-schedule/:id', component: CreateSchedulePopupComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/register-user', component: CreateUserComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/users', component: UsersComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/clothing', component: AdminClothingSettingsComponent, canActivate: [AuthGuard, TestGuard, SkillRoleGuard], data: {roles: ['ROLE_ADMIN']}},
      {path: 'admin/clothing/assignments', component: AdminClothingAssignmentsComponent, canActivate: [AuthGuard, TestGuard, SkillRoleGuard], data: {roles: ['ROLE_ADMIN']}},
      {path: 'admin/clothing/report', component: AdminClothingReportComponent, canActivate: [AuthGuard, TestGuard, SkillRoleGuard], data: {roles: ['ROLE_ADMIN']}},
      {path: 'admin/users/standarts-report/:id', component: UsersStandartsReportComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/create-group', component: CreateGroupComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/create-position', component: CreatePositionComponent, canActivate: [AuthGuard, TestGuard]},
      {
        path: 'admin/deal-payroll-catalog',
        component: ViewUserReportComponent,
        canActivate: [AuthGuard, TestGuard, SkillRoleGuard],
        data: DEAL_PAYROLL_SETTINGS_ROUTE_DATA
      },
      {path: 'company-structure', component: CompanyStructureComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'company-structure-user', component: DepartmentsTabsUserComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/create-standard', component: CreateStandardComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/all-standards', component: AllStandardsComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/all-standards-head', component: StandartTabsComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/all-standards-head-only', component: StandartTabsHeadComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/deratment-standards/:id', component: AllStandardsComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'standards-management', component: StandardsManagementComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'admin/standards-management-admin', component: StandartsTabsAdminComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'my-created-standards', component: MyCreatedStandards, canActivate: [AuthGuard, TestGuard]},
      {path: 'groups/:id', component: ViewGroupComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'groups/:id/:rep', component: ViewGroupComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'standard/:id', component: ViewStandardComponent, canActivate: [AuthGuard, TestGuard]},
      {
        path: 'standard-discussion/:id',
        component: StandardDiscussionPageComponent,
        canActivate: [AuthGuard, TestGuard],
        data: {fullscreenLayout: true}
      },
      {path: 'profile/:id', component: ViewUserProfileComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'user/edit/:id', component: EditUserProfileComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'group/edit/:id', component: EditGroupDetailsComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'standard/:id/blanks', component: BlanksStandardComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'group/:id/standards', component: StandardDisseminationComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'operating-standard', component: OperatingStandardComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'familiarize-standard/:id', component: UserFamiliarizeStandardComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'confirm-standard/:id', component: UserConfirmStandardComponent, canActivate: [AuthGuard, TestGuard]},
      {
        path: 'general-settings',
        component: ViewUserReportComponent,
        canActivate: [AuthGuard, TestGuard, SkillRoleGuard],
        data: GENERAL_SETTINGS_ROUTE_DATA
      },
      {
        path: 'create-operating-standard',
        component: CreateOperatingStandardComponent,
        canDeactivate: [CanDeactivateGuardService],
        canActivate: [AuthGuard, TestGuard],
        children: [
          {path: '', component: OpstStepOneComponent, canActivate: [AuthGuard, TestGuard], canDeactivate: [CanDeactivateGuardService]},
          {path: 'step-two', component: OpstStepTwoComponent, canActivate: [AuthGuard, TestGuard]},
          {path: 'step-three', component: OpstStepThreeComponent, canActivate: [AuthGuard, TestGuard]},
          {path: 'step-four', component: OpstStepFourComponent, canActivate: [AuthGuard, TestGuard]},
          {path: 'step-five', component: OpstStepFiveComponent, canActivate: [AuthGuard, TestGuard]},
          {path: 'step-six', component: OpstStepSixComponent, canActivate: [AuthGuard, TestGuard]},
          {path: 'step-seven', component: OpstStepSevenComponent, canActivate: [AuthGuard, TestGuard]},
          {path: 'step-eight', component: OpstStepEightComponent, canActivate: [AuthGuard, TestGuard]},
        ]
      },
      {path: 'operating-standards', component: OperatingStandardListAllComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'create-suggestion-list', component: CreateNewSlistComponent, canActivate: [AuthGuard, TestGuard], canDeactivate: [PwaSuggestionLeaveGuard]},
      {path: 'create-suggestion-list/:id', component: CreateNewSlistComponent, canActivate: [AuthGuard, TestGuard], canDeactivate: [PwaSuggestionLeaveGuard]},
      {
        path: 'my-suggestion-lists',
        component: MySuggestionListsComponent,
        canActivate: [AuthGuard, TestGuard],
        children: [
          {path: '', pathMatch: 'full', redirectTo: 'my-lists', canActivate: [AuthGuard, TestGuard]},
          {path: 'my-lists', component: MySlTabComponent, canActivate: [AuthGuard, TestGuard]},
          {path: 'my-drafts', component: MyDraftsTabComponent, canActivate: [AuthGuard, TestGuard]},
          {path: 'all-suggestion-lists', component: AllSuggestionListsComponent, canActivate: [AuthGuard, TestGuard]},
          {path: 'for-review-suggestion-lists', component: ForReviewSuggestionListsComponent, canActivate: [AuthGuard, TestGuard]},
        ]
      },
      {path: 'suggestion-list-details/:id', component: ViewSuggestionListComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'specializations-list', component: SpecializationsListComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'add-specialization', component: AddNewSpecializationComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'edit-specialization', component: EditSpecializationComponent, canActivate: [AuthGuard, TestGuard]},
      {
        path: 'admin/ai-statistics',
        component: AiStatisticsContainerComponent,
        canActivate: [AuthGuard, TestGuard, SkillRoleGuard],
        data: {roles: ['ROLE_ADMIN'], fullscreenLayout: true}
      },
      {path: 'specializations', component: SkillSpecializationListContainerComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'specializations/create', component: CreateSpecializationContainerComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'specializations/:id/edit', redirectTo: 'specializations/:id/edit/general', pathMatch: 'full'},
      {
        path: 'specializations/:id/edit/general',
        component: EditSpecializationContainerComponent,
        canActivate: [AuthGuard, TestGuard],
        data: {fullscreenLayout: true}
      },
      {
        path: 'specializations/:id/edit/levels',
        component: EditSpecializationContainerComponent,
        canActivate: [AuthGuard, TestGuard],
        data: {fullscreenLayout: true}
      },
      {path: 'user/:id/qualifications-list', component: QualificationsListComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'start-learning', component: StartLearningComponent, canActivate: [AuthGuard, TestGuard]},
      {path: 'learning', component: LearningTreeContainerComponent, canActivate: [AuthGuard, TestGuard]},
      {
        path: 'learning/department/:groupId',
        component: DepartmentStarMapComponent,
        canActivate: [AuthGuard, TestGuard],
        data: {fullscreenLayout: true}
      },
      {
        path: 'learning/:specializationId',
        component: LearningSessionContainerComponent,
        canActivate: [AuthGuard, TestGuard],
        data: {fullscreenLayout: true}
      },
      {path: 'achievements', component: AchievementsComponent, canActivate: [AuthGuard, TestGuard]}
    ]
  },
  {path: 'signin', component: SigninComponent},
  {path: 'install', component: PwaInstallHelpComponent},
  {path: 'change-password', component: ChangePassComponent},
  {path: 'ex-notifications', component: ExNotificationsListComponent},
  {path: 'ex-notification-familiarize-action/:id', component: ExNotificationFamiliarizeActionComponent},
  {path: 'ex-notification-confirm-action/:id', component: ExNotificationConfirmActionComponent},
  {path: 'ex-suggestion-expired/:id/:notifyId', component: ViewSuggestionListComponent},

  {path: 'email-notification/:id', component: FromEmailLinkComponent, canActivate: [AuthGuard]},

  {path: 'translate-questions/:id', component: TranslateQuestionsComponent, canActivate: [AuthGuard, PwaRouteGuard]},
  {path: 'translate-standard/:id', component: TranslateStandardComponent, canActivate: [AuthGuard, PwaRouteGuard]}
];

@NgModule({
  declarations:[
    PwaDashboardLandingComponent, PwaInstallHelpComponent,
    BrowserOnlyDirective, PwaOnlyDirective, PwaModeDirective, PwaInstallDirective,
    PhonePrimaryDepartmentLinkDirective,
    EmployeeServiceAnchorDirective,
    ClothingProfileDispositionsComponent,
    WorkflowTimestampPipe,
    UtcCalendarDatePipe,
    WorkflowModalFocusDirective,
    OffboardingHistoryEventComponent,
    AssetIssueModalComponent,
    DepartmentAssetsModalComponent,
    AssetProfileIssueComponent,
    AssetActionModalComponent,
    WorkflowMenuDirective,
    OffboardingUnavailableComponent,
    ClothingDispositionComponent,
    ClothingDispositionModalComponent,
    OffboardingProfileComponent,
    OffboardingPersonSearchComponent,
    OffboardingAssignmentEditorComponent,
    OffboardingItemComponent,
    OffboardingCollectionComponent,
    OffboardingApprovalComponent,
    OffboardingReplacementsComponent,
    OffboardingNotePreviewComponent,
    OffboardingReturnsComponent,
    OffboardingReturnModalComponent,
    OffboardingPayrollComponent,
    OffboardingNotificationComponent,
    OffboardingListComponent,
    OffboardingArchiveDetailComponent,
    OffboardingArchiveImportComponent,
    OffboardingCreateComponent,
    OffboardingDetailComponent,
    OffboardingBraceDirective,
    OffboardingActionModalComponent,
    OffboardingAssignmentsComponent,
    HeadNotificationComponent,
    EmployeeProbationComponent,
    EmployeeOnboardingComponent,
    SalarySourcesComponent,
    ViewUserTasksComponent,
    SafeHtmlPipe,
    ContentTranslationPipe,
    StandardContentTranslationPipe,
    SwitchComponent,
    ThermometerComponent,
    CustomTooltipDirective,
    DisableKeyboardInputDirective,
    ChunkPipe,
    DislikeListComponent,
    BiometricsComponent,
    BiometryRequiredComponent,
    GetClotheComponent,
    ChangeKarmaDescriptionComponent,
    ClothingItemNameKeyPipe,
    Autosize,
    AppComponent,
    HeaderComponent,
    SigninComponent,
    NavbarComponent,
    DashboardComponent,
    ContentPageComponent,
    MyGroupsComponent,
    MyStandardsComponent,
    MyStandardsCatalogComponent,
    PhoneStandardsComponent,
    MyWorkingReportComponent,
    DealPayrollDetailComponent,
    DealPayrollDetailTriggerDirective,
    HomeTasksComponent,
    MyProfileComponent,
    MyProfileSummaryComponent,
    MyProfileAssetsComponent,
    StandardPinsComponent,
    StandardPinCheckboxComponent,
    StandardAssignmentPinsDirective,
    GradeGrowthComponent,
    GradePromotionComponent,
    DropdownDirective,
    CreateSchedulePopupComponent,
    CreateUserComponent,
    UsersComponent,
    AdminClothingSettingsComponent,
    AdminClothingAssignmentsComponent,
    AdminClothingReportComponent,
    ClothingProcurementForecastComponent,
    ClothingCatalogModalComponent,
    ClothingAdminSettingsFormComponent,
    ClothingAdminMarkerDirectoryComponent,
    ClothingAdminPersonalNormsComponent,
    ClothingAdminMatrixComponent,
    ClothingAdminDepartmentMarkerComponent,
    ClothingMarkerModalComponent,
    ClothingMarkerAssignmentPanelComponent,
    CreateGroupComponent,
    CreatePositionComponent,
    DealPayrollCatalogComponent,
    DealPayrollRatesComponent,
    TasksPanelComponent,
    CompanyStructureComponent,
    CreateStandardComponent,
    CreateStandardHeadComponent,
    AllStandardsComponent,
    EditStandardComponent,
    ViewStandardComponent,
    ViewGroupComponent,
    DealPayrollGroupSettingsComponent,
    DealPayrollDecimalInputDirective,
    DealPayrollGroupSettingsTriggerDirective,
    ViewUserProfileComponent,
    DealPayrollUserSettingsComponent,
    ViewUserReportComponent,
    ViewUserTasksComponent,
    EditUserProfileComponent,
    TaskFullviewPopupComponent,
    CalendarTimezoneMarkerModalComponent,
    TestingPageComponent,
    ReportDatepickerComponent,
    VacationBookingPanelComponent,
    VacationAvailabilityCalendarComponent,
    VacationPresenceBadgeComponent,
    VacationTeamCalendarComponent,
    ConfirmDelete,
    SearchParams,
    AddDepartments,
    TaskPipePipe,
    AddMemberPopupComponent,
    EditGroupPopupComponent,
    SetHeadDeputyComponent,
    ViewStandardsComponent,
    ConfirmationPopupComponent,
    ConfirmPopupComponent,
    EditGroupDetailsComponent,
    BlanksStandardComponent,
    StandardDisseminationComponent,
    StandardAssignmentCleanupComponent,
    AddNewQuestionsComponent,
    EditStandardInfoComponent,
    ChangeUserPositionComponent,
    RenamePositionComponent,
    ChangeSalaryComponent,
    ChangeExperienceComponent,
    ChangeModalComponent,
    ChangeModalsComponent,
    InfoPopupComponent,
    ChangeUserPasswordComponent,
    OperatingStandardComponent,
    CreateOperatingStandardComponent,
    OperatingStandardListAllComponent,
    OpstStepOneComponent,
    OpstStepTwoComponent,
    OpstStepThreeComponent,
    OpstStepFourComponent,
    OpstStepFiveComponent,
    OpstStepSixComponent,
    OpstStepSevenComponent,
    StandardActionModalComponent,
    AddStandardPrefixComponent,
    AddStandardPrefixComponentHead,
    EditStandardPrefixComponent,
    AddStandardTypeComponent,
    EditStandardTypeComponent,
    ChatComponent,
    UserConfirmStandardComponent,
    UserFamiliarizeStandardComponent,
    StepCreateTestingComponent,
    TestingActionComponent,
    OpstStepEightComponent,
    AddUserStepsComponent,
    StepConfirmPopupComponent,
    AddQuestionStepPopupComponent,
    AddChanglogComponent,
    StepChangelogsComponent,
    ExNotificationsListComponent,
    ExNotificationsActionComponent,
    ExNotificationFamiliarizeActionComponent,
    ExNotificationConfirmActionComponent,
    FromEmailLinkComponent,
    EditStandardNumberComponent,
    LanguageSwitcherComponent,
    TranslateStandardComponent,
    TranslateQuestionsComponent,
    TreeGroupPosBlockComponent,
    CreateNewSlistComponent,
    MySuggestionListsComponent,
    AllSuggestionListsComponent,
    ViewSuggestionListComponent,
    MySlTabComponent,
    MyDraftsTabComponent,
    ImplementationMembersComponent,
    ActionSlPopupComponent,
    AddChanglogComponent,
    ForReviewSuggestionListsComponent,
    AllSuggestionListsComponent,
    SpecializationsListComponent,
    AddNewSpecializationComponent,
    QualificationsListComponent,
    LearningComponent,
    EditSpecializationComponent,
    StartLearningComponent,
    SetLevelComponent,
    ConfirmScheduleComponent,
    SpecWarningComponent,
    ViewDocxComponent,
    StepsFilesComponent,
    StepsBlanksComponent,
    AlertShowComponent,
    EditQuestionComponent,
    EditStandardNumberPopupComponent,
    StandardsManagementComponent,
    MyCreatedStandards,
    RemoveUserComponent,
    AssignStandardsComponent,
    CancelPopupComponent,
    RenamePipe,
    SuggestionStatusKeyPipe,
    EditStandardPrefixComponentHead,
    AddStandardTypeComponentHead,
    EditStandardTypeComponentHead,
    EditStandardNumberComponentHead,
    StandartTabsComponent,
    StandartTabsHeadComponent,
    DepartmentsTabsUserComponent,
    StandartsTabsAdminComponent,
    AchievementsComponent,
    VectorValueComponent,
    ChangePassComponent,
    UsersStandartsReportComponent,
    ClothingHeadExtensionModalComponent,
    ClothingIssueModalComponent,
    ClothingLossModalComponent,
    ClothingHeadLossDecisionModalComponent,
    ClothingStorekeeperRequestActionModalComponent,
    StorekeeperEmployeesComponent,
    StandardDiscussionPageComponent,
    EmployeeStandardOverridesModalComponent,
    EmployeeStandardUserSelectorComponent,
    EmployeeStandardMatrixComponent,
    ClothingMarkerOverridesModalComponent,
    MorningOvertimePromptContainerComponent,
    MorningOvertimePromptComponent,
    MorningOvertimeHeadActionComponent
  ],
  entryComponents: [
    OffboardingArchiveDetailComponent,
    AssetIssueModalComponent,
    DepartmentAssetsModalComponent,
    AssetActionModalComponent,
    ClothingDispositionModalComponent,
    OffboardingActionModalComponent,
    OffboardingReturnModalComponent,
    DealPayrollDetailComponent,
    DealPayrollGroupSettingsComponent,
    DislikeListComponent,
    BiometricsComponent,
    GetClotheComponent,
    VectorValueComponent,
    ChangeKarmaDescriptionComponent,
    AddMemberPopupComponent,
    EditGroupPopupComponent,
    SetHeadDeputyComponent,
    AddNewQuestionsComponent,
    ViewStandardsComponent,
    EditStandardInfoComponent,
    ConfirmDelete,
    SearchParams,
    AddDepartments,
    ReportDatepickerComponent,
    ConfirmationPopupComponent,
    ConfirmPopupComponent,
    ChangeUserPositionComponent,
    RenamePositionComponent,
    ChangeSalaryComponent,
    ChangeExperienceComponent,
    ChangeModalComponent,
    ChangeModalsComponent,
    InfoPopupComponent,
    ChangeUserPasswordComponent,
    StandardActionModalComponent,
    AddStandardPrefixComponent,
    AddStandardPrefixComponentHead,
    EditStandardPrefixComponent,
    AddStandardTypeComponent,
    EditStandardTypeComponent,
    EditStandardPrefixComponentHead,
    AddStandardTypeComponentHead,
    EditStandardTypeComponentHead,
    EditStandardNumberComponentHead,
    StepConfirmPopupComponent,
    AddChanglogComponent,
    EditStandardNumberComponent,
    ClothingCatalogModalComponent,
    ClothingMarkerModalComponent,
    ActionSlPopupComponent,
    CancelPopupComponent,
    SetLevelComponent,
    SpecWarningComponent,
    ViewDocxComponent,
    AlertShowComponent,
    EditQuestionComponent,
    EditStandardNumberPopupComponent,
    RemoveUserComponent,
    AssignStandardsComponent,
    EmployeeStandardOverridesModalComponent,
    ClothingMarkerOverridesModalComponent,
    ClothingHeadExtensionModalComponent,
    ClothingIssueModalComponent,
    ClothingLossModalComponent,
    ClothingHeadLossDecisionModalComponent,
    ClothingStorekeeperRequestActionModalComponent,
    CalendarTimezoneMarkerModalComponent
  ],
  imports: [
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
      },
  }),
    BrowserModule,
    HttpModule,
    HttpClientModule,
    HttpClientXsrfModule,
    FormsModule,
    RouterModule.forRoot(appRoutes),
    NgbModule.forRoot(),
    ReactiveFormsModule,
    JsonpModule,
    NgxPaginationModule,
    TreeTableModule,
    NgBootstrapFormValidationModule.forRoot(),
    AngularFontAwesomeModule,
    Ng2SearchPipeModule,
    SkillLearningModule,
    NotifierModule.withConfig( {
      // Legacy native animation callbacks can leave an invisible notification over navigation.
      animations: { enabled: false },
      position: {
        horizontal: {
          position: 'right',
          distance: 12
        },
        vertical: {
          position: 'top',
          distance: 60,
          gap: 10
        }
      },
      theme: 'material'
    })
  ],
  providers: [
    EmployeeOnboardingService,
    PwaPlatform, PwaModeService, PwaInstallService, PwaRouteGuard, PwaLandingService, PwaSuggestionLeaveGuard,
    EmployeeAssetsService, ClothingDispositionService, OffboardingService,
    OffboardingNoteViewService, OffboardingReturnGateway, WorkflowPageGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    CookieService,
    AuthService,
    AuthGuard,
    BiometryGuard,
    TestGuard,
    UserService,
    UserReportService,
    SidebarService,
    HeaderService,
    MobileMenuService,
    WorkTimeService,
    TaskBarService,
    AdminService,
    ClothingService,
    ClothingErrorService,
    ClothingNotificationActionService,
    ClothingNotificationDisplayService,
    ClothingNotificationRoutingService,
    ProfileClothingViewService,
    ApiConnectService,
    ApiService,
    TaskDescService,
    ReportService,
    DealPayrollService,
    DealPayrollSettingsService,
    GradePromotionService,
    FabMessageService,
    TimeFormatterService,
    TestingService,
    TestingDataService,
    ComponentBackgroundService,
    OperatingStandardService,
    CanDeactivateGuardService,
    PrefixService,
    StandardTypesService,
    StepsControllerService,
    NotificationsService,
    StandardDiscussionApiService,
    MessageService,
    StepTestingService,
    TestingProcessService,
    AddStepUserService,
    StepTempControllerService,
    ExNotificationsService,
    OperatingStandardComponent,
    UserConfirmStandardComponent,
    UserFamiliarizeStandardComponent,
    TreeGroupPosService,
    LanguageSwitcher,
    UiLocaleService,
    SuggestionListsService,
    ReviewSuggestionListsService,
    ChatSuggestionListsService,
    NgbDropdown,
    SuggestionListsService,
    LearningService,
    SpecializationsService,
    UserQualificationsService,
    ViewDocxService,
    StdManagementService,
    SortTableService,
    MyCreatedStandards,
    NgbActiveModal,
    UpdateService,
    ToastService,
    EmployeeStandardOverridesService,
    MorningOvertimeReadinessApiService,
    MorningOvertimeReadinessFacadeService,
    VacationApiService,
    CalendarTimezoneDataService
  ],
  bootstrap: [AppComponent]
})


export class AppModule {
}




// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/app.module.ts